import "mapbox-gl/dist/mapbox-gl.css";
import { AppProps } from "next/app";
import { Translation } from "react-i18next";
import { ErrorMessage } from "../components/ErrorMessage";
import "../global.css";
import "../helpers/polyfills.ts";
import { configureSentry } from "../helpers/sentry";
import { appWithTranslation } from "next-i18next";
import React, { useState, useEffect } from "react";

const { Sentry, captureException } = configureSentry();

function CustomApp({ Component, pageProps }: AppProps) {
  const [hasError, setHasError] = useState(pageProps.hasError || false);
  const [errorEventId, setErrorEventId] = useState(pageProps.errorEventId);

  useEffect(() => {
    if (pageProps.hasError) {
      setHasError(true);
      setErrorEventId(pageProps.errorEventId);
    }
  }, [pageProps]);

  // This is a simple way to handle errors caught by Next.js's default error boundary
  // You can expand this with getDerivedStateFromError like functionality if needed
  if (pageProps.err) {
      // You can capture the error here, for example:
      // const capturedEventId = captureException(pageProps.err);
      // And then manage state accordingly
  }

  const component = <Component {...pageProps} />;

  // Error boundary can be implemented here if needed, for now, a simple check
  if (hasError) {
    return (
      <ErrorMessage>
        <Translation
          children={(t, { i18n }) => (
            <>
              {t("error_message")}{" "}
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  Sentry.showReportDialog({
                    eventId: errorEventId,
                    lang: i18n.language,
                    title: t("error_report-title"),
                    subtitle: t("error_report-subtitle"),
                    subtitle2: "",
                    successMessage: t("error_report-success"),
                  });
                }}
              >
                {t("error_report")}
              </a>
            </>
          )}
        />
      </ErrorMessage>
    );
  }

  return component;
}

export default appWithTranslation(CustomApp);